import Config from "@/const/Config";
import { BaseApi } from "./BaseApi";

export class AuthCheckerApi extends BaseApi {

  API_PREFIX_CORE = '/syain/core/'
  /**
   * ログイン
   * @returns 
   */
  public async tenpuFileControl(userId: number): Promise<boolean> {
    try {
      const req = {userId: userId}
      const res = await this.post(Config.API_URL + this.API_PREFIX_CORE + 'file_auth', req)
      if(res.status !== 200){
        throw new Error("")
      }
      return true
    } catch (e: unknown) {
      console.error('auth error: ', e)
      throw e
    }
  }
}